module.exports = __webpack_public_path__ + "static/media/loc1_img11.1658aa0d.jpg";